module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "id": "upload-avatar"
    }
  }, [_c('mu-row', {
    staticStyle: {
      "align-items": "center"
    },
    attrs: {
      "align": "left"
    }
  }, [(!_vm.hideAvatar && _vm.$store.state.user.scope.profile_large) ? _c('mu-col', {
    attrs: {
      "desktop": "10",
      "tablet": "15",
      "width": "20"
    }
  }, [_c('mu-avatar', {
    staticStyle: {
      "height": "50px",
      "width": "50px"
    },
    attrs: {
      "src": _vm.$store.state.user.scope.profile_large ? _vm.$store.state.user.scope.profile_large : 'static/avatar.png'
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.hideAvatar) ? _c('mu-col', {
    attrs: {
      "desktop": "90",
      "tablet": "85",
      "width": "80",
      "align": "left"
    }
  }, [(!_vm.isSaving) ? _c('mu-flat-button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "icon": "add_a_photo",
      "label": _vm.$store.state.user.scope.profile_large === null ? 'Upload avatar' : _vm.$t('message.accountPreferencesChangeAvatar')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openInput()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isSaving) ? _c('mu-col', {
    staticStyle: {
      "align-items": "center"
    }
  }, [_c('mu-circular-progress', {
    staticStyle: {
      "margin-left": "16px"
    },
    attrs: {
      "size": 16
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "inline-flex",
      "margin-left": "8px"
    }
  }, [_vm._v("\n             Uploading picture\n        ")])], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('vue-base64-file-upload', {
    attrs: {
      "disable-preview": "",
      "placeholder": "Click to change profile pic",
      "accept": "image/png,image/jpeg",
      "max-size": _vm.customImageMaxSize
    },
    on: {
      "size-exceeded": _vm.onSizeExceeded,
      "load": _vm.onLoad
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isImagePresent),
      expression: "isImagePresent"
    }]
  }, [_c('div', {
    ref: "imageCropper"
  }), _vm._v(" "), (_vm.isSaving) ? _c('mu-content-block', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_vm._v("Uploading...")])], 1) : _vm._e(), _vm._v(" "), (!_vm.isSaving) ? _c('mu-card-actions', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isImagePresent),
      expression: "isImagePresent"
    }],
    attrs: {
      "align": "center"
    }
  }, [(!_vm.isSaving) ? _c('mu-icon-button', {
    attrs: {
      "tooltip": "Cancel",
      "icon": "close",
      "label": "Cancel"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.doCancel()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('mu-icon-button', {
    attrs: {
      "tooltip": "Rotate left",
      "icon": "rotate_left"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.rotate('left')
      }
    }
  }), _vm._v(" "), _c('mu-icon-button', {
    attrs: {
      "tooltip": "Rotate right",
      "icon": "rotate_right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.rotate('right')
      }
    }
  }), _vm._v(" "), _c('mu-circular-progress', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSaving),
      expression: "isSaving"
    }],
    attrs: {
      "size": 16
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "secondary": "",
      "icon": "crop",
      "label": _vm.isSaving ? 'Uploading...' : 'Save profile picture'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.doCrop()
      }
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-98b4c286","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UploadAvatar/UploadAvatar.vue
// module id = 3267
// module chunks = 1